export const ASPECT_EPS = 0.005

export const getImageSizeFromBlob = (blob) =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
            resolve({width: img.naturalWidth, height: img.naturalHeight});
            URL.revokeObjectURL(url)
        }
        img.onerror = (e) => {
            URL.revokeObjectURL(url)
            reject(e)
        }
        img.src = url
    })

export function aspectToRatioString(aspect) {
    const candidates = [
        [9 / 16, "9:16"],
        [16 / 9, "16:9"],
        [4 / 5, "4:5"],
        [5 / 4, "5:4"],
        [1, "1:1"],
        [3 / 4, "3:4"],
        [4 / 3, "4:3"],
    ];
    for (const [val, label] of candidates) {
        if (Math.abs(aspect - val) < 0.01) return label;
    }
    if (Math.abs(aspect - 1.91) < 0.02) return "1.91:1";

    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    let w = Math.round(aspect * 100);
    let h = 100;
    const d = gcd(w, h);
    w = w / d;
    h = h / d;
    return `${w}:${h}`;
}


export function getAllowedAspectRange({ socialNetwork = '', isStories = false } = {}) {
    const sn = String(socialNetwork).toLowerCase();

    if (sn.includes('instagram') && isStories) {
        const min = 9 / 16, max = 9 / 16;
        return { min, max, label: 'IG Stories', minLabel: '9:16', maxLabel: '9:16' };
    }

    if (sn.includes('instagram')) {
        const min = 4 / 5, max = 1.91;
        return { min, max, label: 'IG Feed', minLabel: '4:5', maxLabel: '1.91:1' };
    }

    if (sn.includes('threads')) {
        const min = 4 / 5, max = 1.91;
        return { min, max, label: 'Threads', minLabel: '4:5', maxLabel: '1.91:1' };
    }

    if (sn.includes('facebook')) {
        const min = 1.0, max = 1.91;
        return { min, max, label: 'Facebook', minLabel: '1:1', maxLabel: '1.91:1' };
    }

    if (sn.includes('linkedin')) {
        const min = 1.0, max = 1.91;
        return { min, max, label: 'LinkedIn', minLabel: '1:1', maxLabel: '1.91:1' };
    }

    const min = 0.5, max = 2.0;
    return { min, max, label: 'Generic', minLabel: '1:2', maxLabel: '2:1' };
}

export const getAspect = (w, h) => (h ? w / h : 0);
export const isAspectInRange = (a, {min, max}, eps = ASPECT_EPS) =>
    a >= min - eps && a <= max + eps;

